import styled from 'styled-components';

const MessageList = styled.ol`${({ theme }) => `
  list-style-type: none;
  padding-right: ${theme.padding[2]};
  padding-left:  ${theme.padding[5]};
  margin: 0;
`}`;

const MessageListItem = styled.li`  
  line-height: ${({ theme }) => theme.padding[6]};
`;

const MessageListMarker = styled.span`
  color: ${({ theme }) => theme.textPrimary};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  padding-right: ${({ theme }) => theme.padding[2]};
`;

export function AlertMessageList({ messages }: {messages: string[]}) {
  return (
    <MessageList>
      {messages.map((item, index) => (
        <MessageListItem key={`alert-message-${index + 1}`}>
          <MessageListMarker>&#8226;</MessageListMarker>
          {item}
        </MessageListItem>
      ))}
    </MessageList>
  );
}
